import type { StyleProps } from "@ui/types";

export const styles = {
    wrapper: {
        display: "flex",
        flexDirection: "column",
        pt: 2,
        width: "100%",
        minHeight: "332px",
        flex: 1,
        justifyContent: "space-between",
    },
    headerBox: {
        textAlign: "left",
        fontWeight: "bold",
    },
    headerFadeBox: {
        color: "white",
        textTransform: "uppercase",
        fontWeight: "bold",
        fontSize: "mobileH1",
    },
    descriptionBox: {},
    descriptionFadeBox: {
        color: "white",
        alignSelf: "center",
    },
} satisfies Record<string, StyleProps>;
